import { Modal } from "@/components";
import styles from "./index.module.scss";
import { useCommonStore } from "@/stores";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { CloseSvg } from "@/assets/icons";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const MultiFaceSelect = () => {
  const { t } = useTranslation();

  const [activeIndex, setActiveIndex] = useState<number>(0);

  const multiFaceSelectOptions = useCommonStore(state => state.multiFaceSelectOptions);
  const setMultiFaceSelectOptions = useCommonStore(state => state.setMultiFaceSelectOptions);

  const faceList = multiFaceSelectOptions.faceDetectionList?.map(item => ({
    ...item,
    faceBlobUrl: URL.createObjectURL(item.face!),
  }));

  const handleSelect = () => {
    multiFaceSelectOptions.onSelect?.(multiFaceSelectOptions.faceDetectionList?.[activeIndex]!);
    setMultiFaceSelectOptions({ show: false });
  }
  const handleClose = () => {
    multiFaceSelectOptions.onClose?.();
    setMultiFaceSelectOptions({ show: false });
  }

  useEffect(() => {
    return () => {
      faceList?.forEach(item => URL.revokeObjectURL(item.faceBlobUrl));
    }
  }, []);

  return (
    <Modal
      closeVisible={false}
    >
      <div
        className={styles["root"]}
      >
        <button
          className={styles["close_button"]}
          onClick={handleClose}
        >
          <CloseSvg></CloseSvg>
        </button>

        <div
          className={styles["title"]}
        >
          <span>{t("select_face_modal_title")}</span>
        </div>

        <OverlayScrollbarsComponent
          className={styles["custom_scrollbar"]}
          style={{}}
          defer
        >
          <div
            className={styles["face_grid"]}
          >
            {faceList?.map((item, index) => (
              <button
                key={index}
                className={clsx(
                  styles["face_wrap"],
                  activeIndex === index && styles["active"]
                )}
                onClick={() => setActiveIndex(index)}
              >
                <img
                  className={styles["face"]}
                  src={item.faceBlobUrl}
                  alt=""
                />
              </button>
            ))}
          </div>
        </OverlayScrollbarsComponent>

        <div
          className={styles["select_button_row"]}
        >
          <button
            className={styles["select_button"]}
            onClick={handleSelect}
          >
            <span>{t("select_face_modal_confirm_btn")}</span>
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default MultiFaceSelect;
